module.exports = __webpack_public_path__ + "static/media/hamideh.ad5c467e.png";